function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m84.7 82.4h3.5l7.4.1-18.8-24.2h1.4l6.4.1-25.2-41.4-25.2 41.3h7.8l-18.7 24.1h10.5l-16.8 20.5h7.5 69.7l7.8.1zm-52.7 13.4 16.7-20.5h-10.9l18.8-24.1h-9.7l12.5-20.5 12.5 20.5h-2.4-7.3l18.7 24.1c-1.1 0-2.4 0-3.9 0h-7.7l17.2 20.5c-13.4 0-41.1 0-54.5 0z",
  fill: "#015168",
  fillRule: "evenodd"
});

var SvgKavely = function SvgKavely(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 120 120",
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKavely, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kavely.79029dfb.svg";
export { ForwardRef as ReactComponent };